// THIS IS THE FILE WHICH CONTAINS THE MODAL FOR FOLLOW UP

import React, { memo, useState } from "react";
import { FaFileDownload } from "react-icons/fa";
import { toast } from "react-toastify";
import {
  SincerityScoreMap,
  SincerityScoreMapString,
} from "../Service/LeaderboardUtils";
import Service from "../Service/http";
import Util from "../Service/util";
import { FadeLoader } from "react-spinners";
import { BiEditAlt, BiTrashAlt } from "react-icons/bi";

const service = new Service();

function FollowUpModal({
  userId,
  isStudentOrCollege,
  selectedName,
  followupList,
  setFollowupList,
  modalLoaderOn,
}) {
  const [followUpText, setFollowUpText] = useState();
  const [ratingString, setRatingString] = useState();
  const [ratingPoints, setRatingPoints] = useState();
  const [editing, setEditing] = useState(false);
  const [followUpId, setFollowUpId] = useState();
  const currentUser = new Util().getName();
  const isAdmin = new Util().isAdmin();

  const BuildCSV = () => {
    if (followupList.length === 0) {
      return;
    }

    const csvHeaders = [
      "createdAt",
      "created_by",
      "message",
      "updatedAt",
      "updated_by",
      "userId",
      "deletedBy",
      "deletedAt",
      "deleted"
    ];
    let csvContent = csvHeaders.join(",") + "\r\n";

    followupList.forEach((item) => {
      const row = [
        item.createdAt,
        item.created_by,
        item.message,
        item.updatedAt,
        item.updated_by,
        item.userId,
        item.deletedBy ?? "NA",
        item.deletedAt ?? "NA",
        item.isDeleted
      ];
      csvContent += row.map((cell) => `"${cell}"`).join(",") + "\r\n";
    });

    const csvData = encodeURI(csvContent);
    const fileName = `${selectedName}-followup.csv` || "followuplist.csv";
    const link = document.createElement("a");
    link.href = "data:text/csv;charset=utf-8," + csvData;
    link.target = "_blank";
    link.setAttribute("download", fileName);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    toast.success("Downloaded Report Succcessfully");
  };

  const editFollowUp = (efollowup, _id, efollowup_points) => {
    let element = document.getElementById("followupModal");
    element.scrollTo(0, 0);
    setFollowUpText(efollowup);
    setFollowUpId(_id);
    if (efollowup_points !== undefined) {
      setRatingString(SincerityScoreMapString.get(efollowup_points));
      setRatingPoints(efollowup_points);
    }
    setEditing(true);
  };

  const deleteFollowUp = async (_id) => {
    // make an api call to delete this follow up..
    try {
      await service.delete(`api/user/${userId}/followup/${_id}`)

      service.get(`api/user/followup/${userId}`)
      .then((json) => {
        if (json.result !== null) {
          setFollowupList(json.result);
        }
        toast.success("deleted!");
      })
      .catch((error) => {
        toast.error("Someting went wrong");
        console.error(error);
      });

    } catch (err) {
      console.error(err)

    }

  }
// 
  const addfollowUpToList = () => {
    let err = false;

    if (!userId) {
      toast.error("user id was not found!");
      err = true;
    }
    if (!followUpText) {
      toast.error("Follow up can't be empty!");
      err = true;
    }
    if (ratingPoints === undefined) {
      toast.error("Rating points can't be empty!");
      err = true;
    }

    if (err) {
      return;
    }

    service
      .post("api/user/followup", {
        user_id: userId,
        message: followUpText,
        updated_by: currentUser,
        UserPoints: ratingPoints,
      })
      .then((json) => {
        service
          .get(`api/user/followup/${userId}`)
          .then((json) => {
            if (json.result !== null) {
              setFollowupList(json.result);
            }
          })
          .catch((error) => {
            toast.error("Someting went wrong");
            console.log(error);
          });
        toast.success("saved");
      })
      .catch((error) => {
        toast.error("Someting went wrong");
        console.log(error);
      });
    setFollowUpText("");
    setRatingString("FollowUp Rating");
    setRatingPoints(0);
  };

  const editComment = () => {
    let err = false;

    if (!userId) {
      toast.error("user id was not found!");
      err = true;
    }
    if (!followUpText) {
      toast.error("Follow up can't be empty!");
      err = true;
    }
    if (ratingPoints === undefined) {
      toast.error("Rating points can't be empty!");
      err = true;
    }

    if (err) {
      return;
    }

    service
      .put("api/user/followup", {
        user_id: userId,
        message: followUpText,
        updated_by: currentUser,
        followupId: followUpId,
        UserPoints: ratingPoints,
      })
      .then((json) => {
        service
          .get(`api/user/followup/${userId}`)
          .then((json) => {
            if (json.result !== null) {
              setFollowupList(json.result);
            }
            setEditing(false);
            setFollowUpText("");
            setRatingString("FollowUp Rating");
            setRatingString(0);
          })
          .catch((error) => {
            toast.error("Someting went wrong");
            console.log(error);
          });
        toast.success("saved");
      })
      .catch((error) => {
        toast.error("Someting went wrong");
        console.log(error);
      });
  };

  return (
    <div
      style={{ scrollBehavior: "smooth" }}
      className="modal fade"
      id="followupModal"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-xl overflow-auto">
        <div
          className="modal-content overflow-auto"
          style={{ minHeight: "900px" }}
        >
          <div className="sticky-top bg-white">
            <div className="modal-header  bg-primary text-white">
              <h5 className="modal-title text-white" id="exampleModalLabel">
                FollowUp History Of {selectedName}
              </h5>
              <button
                // onClick={clearData}
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
          </div>

          {!isStudentOrCollege && (
            <>
            <div className=" col-lg-6 col-md-12 col-sm-12 mx-auto m-4 w-60">

              <div className="input-group mb-2 ">
                <textarea
                  className="form-control text-primary font-monospace"
                  rows="4"
                  style={{ minWidth: "100%" }}
                  value={followUpText}
                  type="text"
                  placeholder="Enter New Follow up"
                  name="followUpText"
                  onChange={(e) => setFollowUpText(e.target.value)}
                />
                {editing ? (
                  <button
                    onClick={() => editComment()}
                    type="button"
                    className="btn btn-primary"
                    style={{ minWidth: "100%" }}
                  >
                    Edit This Comment
                  </button>
                ) : (
                  <button
                    onClick={() => addfollowUpToList()}
                    type="button"
                    className="btn btn-primary"
                    style={{ minWidth: "100%" }}
                  >
                    Add FollowUp
                  </button>
                )}
              </div>

              <div className="form-group" style={{ display: "flex", gap: "1rem", height: "50px" }}>
                <select
                  className="form-select "
                  name="UserRating"
                  value={ratingString}
                  onChange={(e) => {
                    setRatingString(e.target.value);
                    SincerityScoreMap.has(e.target.value)
                      ? setRatingPoints(SincerityScoreMap.get(e.target.value))
                      : setRatingPoints(0);
                  }}
                  id="exampleSelect1"
                >
                  <option value="default"> FollowUp Rating</option>
                  {Array.from(SincerityScoreMap).map(([followUpString, followUpScore])=>{
                    return (
                    <option value={followUpString}>
                      {`${followUpString} (${followUpScore})`}
                    </option>)
                  })}
                </select>
              <button
                  onClick={() => BuildCSV()}
                  type="button"
                  className="btn btn-success btn-sm"
                >
                  Download FollowUp
                </button>
              </div>
            </div>
            </>
          )}

          <div className="modal-body">
            <div>
              {modalLoaderOn ? (
                <div className="text-center">
                  <FadeLoader color={"green"} />
                </div>
              ) : (
                <div className="timelineClass-For-BodyStyles">
                  <div className="timeline-area">
                    <div className="timeline-container">
                      <div className="timeline-timelines">
                        <h2>Follow-Ups</h2>
                      </div>
                      <div className="timeline-all-timelines">
                        {followupList.length === 0 ? (
                          <div className="timeline-text-nodata">
                            <h6>| ---- No Follow-Ups added yet ---- |</h6>
                          </div>
                        ) : (
                          followupList.map((followupobj, idxi) => {
                            return (
                              <div
                                className="timeline-single-timeline timeline-d-flex-2"
                                key={idxi}
                              >
                                <div className="timeline-blank"></div>
                                <div className="timeline-text timeline-d-flex-2">
                                  <span>
                                    <span
                                      style={{
                                        height: "25px",
                                        width: "25px",
                                        backgroundColor:
                                          followupobj?.followup_points
                                            ? followupobj?.followup_points > 0
                                              ? "green"
                                              : followupobj?.followup_points < 0
                                              ? "red"
                                              : null
                                            : null,
                                        borderRadius: "20px",
                                        display: "inline-block",
                                      }}
                                      className="dot"
                                    ></span>
                                    <p className="h4">
                                      {followupobj?.followup_points}
                                      {followupobj.isDeleted ? <span style={{ color: "red" }}>(Deleted)</span> : null}
                                      {!isStudentOrCollege && !followupobj.isDeleted  &&  (
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "1rem" }}>
                                            {" "}
                                            <BiEditAlt size={35} style={{ cursor: "pointer" }} onClick={() => {
                                              editFollowUp(
                                                followupobj.message,
                                                followupobj._id,
                                                followupobj?.followup_points
                                              );
                                            }} />
                                       {isAdmin && !followupobj.isDeleted &&
                                            <BiTrashAlt size={35} style={{ cursor: "pointer", color: "red" }}
                                            onClick={() => {
                                                if (window.confirm("Are you sure you want to delete this follow up?")) {
                                                  deleteFollowUp(
                                                      followupobj._id
                                                  )
                                                }
                                            }}/>}
                                        </div>
                                      )}
                                    </p>
                                      <h6>
                                      {followupobj.isDeleted ? `Deleted By ${followupobj.deletedBy}: ${new Date(
                                          followupobj.deletedAt
                                        ).toDateString()} \n` : null }
                                      {`Updated By ${followupobj.updated_by}: ${new Date(
                                          followupobj.updatedAt
                                        ).toDateString()}`}
                                      </h6>
                                    <br /> {followupobj.message.toString()}
                                    <br></br>
                                  </span>
                                  <div className="timeline-t-square"></div>
                                </div>
                              </div>
                            );
                          })
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(FollowUpModal);
